const colors = {
  white: "#ffffff",
  black: "#000000",
  blackLighter: "#161819",
  grayDark: "#242529",
  grayLight: "#686867",
  primaryColor: "#f5d042",
  secondaryColor: "#0a174e",
};

export const darkTheme = {
  colors,
  backgroundColor: colors.primaryColor,
  textColor: colors.secondaryColor,
  buttonBgColor: colors.secondaryColor,
  buttonTextColor: colors.primaryColor,
  navBgColor: colors.secondaryColor,
  navTextColor: colors.primaryColor,
};

export const lightTheme = {
  colors,
  backgroundColor: colors.secondaryColor,
  textColor: colors.primaryColor,
  buttonBgColor: colors.primaryColor,
  buttonTextColor: colors.secondaryColor,
  navBgColor: colors.primaryColor,
  navTextColor: colors.secondaryColor,
};
